import { useEffect, useState } from 'react'

import {
  Autocomplete,
  Box,
  Button,
  Icon,
  Input,
  Pagination,
  Spinner,
  Table,
  TableHeader,
} from '@fairfashion/design-system'
import { useNavigate } from 'react-router-dom'
import { useTheme } from 'styled-components'

import { IBrandsResponseDTO } from '../../../../sdk/brand/brand.types'
import { IProductList } from '../../../../sdk/products/products.types'
import { sdk } from '../../../../services/sdk'

export const ProductsTable = () => {
  const [brands, setBrands] = useState<IBrandsResponseDTO[]>([])
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [search, setSearch] = useState('')
  const [selectedBrand, setSelectedBrand] = useState<IBrandsResponseDTO>()
  const [productList, setProductList] = useState<IProductList[]>([])
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const theme = useTheme()

  const getBrands = async () => {
    const response = await sdk.brand.getBrands()

    setBrands(response)
  }

  const handleSearch = async () => {
    setLoading(true)
    try {
      const { data, count } = await sdk.products.getList(
        page,
        10,
        search,
        selectedBrand?.id,
      )

      setTotalPages(Math.ceil(count / 10))
      setProductList(data)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getBrands()
    handleSearch()
  }, [page])

  const headers: TableHeader[] = [
    {
      key: 'code',
      label: 'Código SKU',
      width: '10%',
      minWidth: '150px',
    },
    {
      key: 'description',
      label: 'Nome',
      minWidth: '150px',
    },
    {
      key: 'brandName',
      label: 'Marca',
      width: '100px',
      align: 'center',
    },
    {
      key: 'quantity',
      label: 'Itens',
      width: '100px',
      align: 'center',
    },
    {
      key: 'qrcode',
      label: 'Ver',
      align: 'center',
      width: '80px',
      customRender: (data) => {
        return (
          <Box justifyContent="center" width="100%">
            <Button
              variant="text"
              onClick={() => navigate(`/products/${data.code}`)}
            >
              <Box direction="row" gap={1} alignItems="center">
                <Icon name="menu_search" color="secondary" size={20} />
              </Box>
            </Button>
          </Box>
        )
      },
    },
  ]
  if (!productList) return null

  return (
    <Box
      flex={1}
      width="100%"
      backgroundColor="white"
      direction="column"
      gap={3}
      borderRadius={theme.border_radius.box}
      padding={3}
      border={{
        color: 'grey_5',
        width: 1,
      }}
      boxShadow={theme.box_shadow.card}
    >
      <Box
        width="100%"
        gap={2}
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        flex={1}
      >
        <Box maxWidth="400px" minWidth="140px" flex={1}>
          <Input
            placeholder="Pesquisa"
            adornmentPosition="left"
            adornment={<Icon name="search" size={20} color="grey_2" />}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Box>
        <Box gap={2} flex={1} justifyContent="flex-end">
          <Box maxWidth="250px" minWidth="140px" flex={1}>
            <Autocomplete
              placeholder="Marca"
              options={[{ name: 'Todas', id: 'all' }, ...brands]}
              getOptionLabel={(brand) => (brand as IBrandsResponseDTO).name}
              onChange={(selected) =>
                setSelectedBrand(selected as IBrandsResponseDTO)
              }
            />
          </Box>
          <Button width="100px" onClick={() => handleSearch()}>
            Pesquisar
          </Button>
        </Box>
      </Box>
      {loading ? (
        <Box
          width="100%"
          minHeight="300px"
          justifyContent="center"
          alignItems="center"
        >
          <Spinner />
        </Box>
      ) : (
        <Table
          headers={headers}
          data={productList}
          footer={
            <Box justifyContent="center" width="100%" paddingY={1} paddingX={2}>
              <Pagination
                total={totalPages}
                current={page}
                onChange={(_page) => setPage(_page)}
              />
            </Box>
          }
        />
      )}
    </Box>
  )
}
